import React from 'react';
import TopBarChinese from "../components/TopBarChinese";
import FooterChinese from "../components/FooterChinese";
import ContactFormChinese from '../components/ContactFormChinese';
import "../App.css";

function OurTeamChinese() {
  return (
    <div className="App">
      <TopBarChinese />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh', minHeight: '60vh' }}>
        <div className="our-team-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">我們的團隊</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
在我們的照護服務核心，是一支充滿愛與關懷的團隊。我們的專業成員來自多元背景，包括看護、個人支援服務、護理、居家清潔等領域，卻有著共同的使命：為您的摯愛提供同理心、值得信賴且貼心的個人化照護。

我們深信，優質的照護始於真誠的連結。因此，我們的專業團隊會與您及您的家人密切合作，量身打造隨需求成長與調整的個人化照護計畫。您也能根據需要，自由選擇並掌握從日常支援到專業照護的多元服務。

我們始終陪伴在側，以溫暖、穩定與真心，守護您每一步。          
          </p>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
            我們深知照護責任的沉重，這並非一條能輕鬆獨行的道路。政府的支援雖然存在，卻往往難以完全滿足實際需求。正因如此，我們的存在是為了協助您分擔這份重擔。在我們可靠、專業且富有同理心的團隊支持下，

您可以更專注於最重要的事——與摯愛共享珍貴時光，其他事務則交由我們悉心照料。
          </p>
          <div style={{ margin: '40px auto', maxWidth: '800px', width: '100%' }}>
            <img 
              src="/group.jpg"
              alt="Connection Health Care 團隊" 
              style={{ 
                width: '100%', 
                height: 'auto', 
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }} 
            />
          </div>
        </div>
      </div>
      <ContactFormChinese />
      <FooterChinese />
    </div>
  );
}

export default OurTeamChinese;